import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-id"]
const _hoisted_2 = { class: "product-element__container q-card q-h-100 q-shadow-sm q-rounded-2 q-position-relative" }
const _hoisted_3 = { class: "product-element__image-container q-card-image" }
const _hoisted_4 = ["alt"]
const _hoisted_5 = { class: "product-element__info-box q-card-body q-p-2" }
const _hoisted_6 = { class: "product-element__title q-fw-normal q-small" }
const _hoisted_7 = ["href"]

import {toRefs, ref} from 'vue'
import {generateStaticImage} from "@/core/utils";
import {config} from "@/core/config";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductItem',
  props: ['product', 'component'],
  setup(__props) {

const props = __props;

const {getTheLookUrl} = config


const {id, link, title, link_click, variants} = toRefs(props.product);
const firstVariant = ref(variants.value[0]).value
const staticImage = ref(generateStaticImage(firstVariant.image_link, 300, null));
const actualLink = ref(`${getTheLookUrl}${config.useHashBeforeParams ? '#': ''}?stylisation=${id.value}`)


return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", {
    class: "product-element q-p-1 q-p-sm-2 q-pb-3",
    "data-id": _unref(id)
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("img", {
          class: "product-element__image mx-auto q-d-block q-card-img-top q-img-fluid",
          alt: _unref(title)
        }, null, 8, _hoisted_4), [
          [_directive_lazy, staticImage.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h6", _hoisted_6, _toDisplayString(_unref(title)), 1)
      ]),
      _createElementVNode("a", {
        class: "product-element__link q-stretched-link",
        href: actualLink.value
      }, null, 8, _hoisted_7)
    ])
  ], 8, _hoisted_1))
}
}

})